import { EditProjectFormData, FormErrors } from './types';

export const validateEditProjectForm = (
  _formData: EditProjectFormData,
): { isValid: boolean; errors: FormErrors } => {
  const errors: FormErrors = {};

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};
